module.exports = "/*\r\n*********************\r\n**    BOOTSTRAP    **\r\n*********************\r\n*/\n:root {\n  --navbar-toggle-border-color: darken(#a82339, 10%); }\n.modal-body {\n  padding-bottom: 0; }\n@media (max-width: 991px) {\n  .col-sm-6:first-child col-vertical-input-container {\n    margin-bottom: 15px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/extratos/relatorio/gerar-relatorio-modal/gerar-relatorio-modal.component.scss
// module id = ./src/app/extratos/relatorio/gerar-relatorio-modal/gerar-relatorio-modal.component.scss
// module chunks = main